module.exports = __webpack_public_path__ + "img/apply_zhanweishenqi.30a04a0.jpg";